import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';
import { createRefetchContainer, graphql, requestSubscription } from 'react-relay';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import environment from '../../environment';

class WMLeftSectionResult extends Component {
    constructor(props){
        super(props);
        this.state = {
            leaderboard: [],
            total_page: 1,
        }
    }

    componentDidMount(){
        const { getLonewolfPersonalLeaderboardData, event_id, quarter_id } = this.props;
        if(getLonewolfPersonalLeaderboardData.getLonewolfPersonalLeaderboardData){
            const data = getLonewolfPersonalLeaderboardData.getLonewolfPersonalLeaderboardData.data;
            this.setState({
                leaderboard: data.leaderboard,
                total_page: data.total_page
            });
        }

        const subscriptionConfig = {
            subscription: graphql`
                subscription WMLeftSectionResultSubscription($event_id: ID!, $quarter_id: ID!){
                    golfLeaderboardFindEventById(event_id: $event_id, quarter_id: $quarter_id){
                        event_id
                        quarter_id
                    }
                }
            `,
            variables: { event_id: event_id, quarter_id: quarter_id },
            onError: error => console.log("Subscription error : ", error),
            updater: store => {
                this.props.refetchData();
            },
        };
        this.subscription = requestSubscription(environment, subscriptionConfig);
    }

    componentDidUpdate(prevProps){
        if(prevProps.quarter_id != this.props.quarter_id) this._refetch();
    }

    componentWillUnmount(){
        this.subscription.dispose();
    }

    render(){
        const { classes, page_number } = this.props;
        const { leaderboard, total_page } = this.state;

        return ([
            <div className={classes.wmTableContainer} key='wm-left-table'>
                <table className={classes.wmTable}>
                    <colgroup>
                        <col style={{width: '20%'}} />
                        <col style={{width: '55%'}} />
                        <col style={{width: '25%'}} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className={classes.wmTableHead} style={{textAlign: 'center'}}>PLACE</th>
                            <th className={classes.wmTableHead} style={{textAlign: 'left'}}>PLAYER</th>
                            <th className={classes.wmTableHead} style={{textAlign: 'center'}}>WINNINGS</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        leaderboard.map((l, i) => {
                            return (
                                <tr key={`leaderboard-${i}`}>
                                    <td className={classes.wmTableRow} style={{textAlign: 'center'}}>{l.position}</td>
                                    <td className={classes.wmTableRow} style={{textAlign: 'left'}}>{l.name}</td>
                                    <td className={classes.wmTableRow} style={{textAlign: 'center'}}>${l.points}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>,
            <div style={{marginTop: '1em'}} key='wm-left-pagination'>
                <div style={{float: 'right', margin: '1em'}}>
            {
                page_number > 1 ?
                <span className={classes.pageArrow2} onClick={() => this.props.changePage(page_number - 1)}>←</span> :
                <span className={classes.pageArrowDisabled2}>←</span>
            }
            {
                Array(total_page).fill(0).map((pg, i) => {
                    if(i + 1 == page_number) return <FiberManualRecordIcon className={classes.currentPage} key={`circleicon-${i}`} />
                    else return <FiberManualRecordIcon className={classes.otherPage} onClick={() => this.props.changePage(i + 1)} key={`circleicon-${i}`} />
                })
            }
            {
                page_number + 1 <= total_page ? 
                <span className={classes.pageArrow2} onClick={() => this.props.changePage(page_number + 1)}>→</span> :
                <span className={classes.pageArrowDisabled2}>→</span>
            }
                </div>
            </div>
        ])
    }
}

export default createRefetchContainer(
    withStyles(useStyles)(WMLeftSectionResult),
    {
        getLonewolfPersonalLeaderboardData: graphql`
            fragment WMLeftSectionResult_getLonewolfPersonalLeaderboardData on Query
                @argumentDefinitions(
                    event_token: { type: "String!" }
                    guest_token: { type: "String!" }
                    quarter_id: { type: "Int!" }
                    page_number: { type: Int }
                    search_val: { type: String }
                ){
                    getLonewolfPersonalLeaderboardData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val){
                        data {
                            leaderboard {
                                name
                                points
                                position
                            }
                            total_page
                        }
                    }
                }
        `
    },
    graphql`
        query WMLeftSectionResultRefetchQuery($event_token: String!, $guest_token: String!, $quarter_id: Int!, $page_number: Int, $search_val: String){
            ...WMLeftSectionResult_getLonewolfPersonalLeaderboardData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val)
        }
    `,
);